// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ukxh","col":"styles_col__3YD3-"};